<div class="footer">
  <div>&copy; Copyright irembo 2023 All rights reserved</div>
  <div>
    <a href="#"><i class="fa-regular fa-question-circle"></i> Support Center</a>
    Follow us on
    <a href="#">
      <img
        src="../../../assets/images/social-icons/twitter.svg"
        class="icon"
        alt="twitter icon" />
    </a>
    <a href="#">
      <img
        src="../../../assets/images/social-icons/facebook.svg"
        class="icon"
        alt="facebook icon" />
    </a>
    <a href="#">
      <img
        src="../../../assets/images/social-icons/linkedin.svg"
        class="icon"
        alt="linkedIn icon" />
    </a>
    <a href="#">
      <img
        src="../../../assets/images/social-icons/medium.svg"
        class="icon"
        alt="Medium icon" />
    </a>
  </div>
  <div><a href="#">Terms of Use</a> &middot; <a href="#">Company</a></div>
</div>
